export {Icon, Icon as default} from './icon';
export type {IconProps} from './icon';
export {default as SingleColor} from './icons-single-color-generated';
export {default as MultiColor} from './icons-multi-color-generated';
export {Icons, Sizes} from './constants';
export type {IconSize, IconType} from './constants';
